import AdminLayout from '../../components/dashboard/admin/AdminLayout';
import UserManagement from '../../components/admin/customers/UserManagement';

const Users = () => {
  return (
    <AdminLayout>
      <UserManagement />
    </AdminLayout>
  );
};

export default Users;